import categoriesData from './categoriesData.json';

export default {
    data: categoriesData
};
